<div class="top-pane">
  <div class="left-pane">
    <div class="header" translate>INBOUND_DASHBOARD.SUMMARY</div>
    <div class="summary">
      <div class="summary-number">{{(results | async)?.data?.total?.answeredCalls}}</div>
      <div class="summary-subtitle" translate>INBOUND_DASHBOARD.ANSWERED_CALLS</div>
    </div>
    <div class="total">
      <div class="total-number">{{(results | async)?.data?.total?.calls}}</div>
      <div class="total-subtitle" translate>INBOUND_DASHBOARD.TOTAL_AMOUNT</div>
    </div>
  </div>
  <div class="right-pane">
    <table class="numbers-table">
      <thead>
        <tr>
          <th class="first-header" translate>INBOUND_DASHBOARD.PER_NUMBER</th>
          <th translate>INBOUND_DASHBOARD.ANSWERED</th>
          <th translate>INBOUND_DASHBOARD.TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of (results | async)?.data?.numbers">
          <td class="msisdn-cell">
            <cc-msisdn [msisdn]="{
            label: item.label,
            msisdn: item.msisdn,
            isoCountry: item.isoCountry
            }"></cc-msisdn>
          </td>
          <td class="answered-cell">{{item.answeredCalls}}</td>
          <td class="total-cell">{{item.allCalls}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="header" translate>INBOUND_DASHBOARD.MONTHLY_SUMMARY</div>
<cc-line-chart [results]="results" [colors]="colors" [config]="config"></cc-line-chart>
